import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ErrorButtonContainer = styled.div<React.CSSProperties>`
  text-align: center;
  margin-top: ${100 * Screen.widthRatio}px;
`;

export default ErrorButtonContainer;
